const getDeepByPath = (query, obj) => {
  const results = [];

  const recurse = (curr, path) => {
    if (typeof curr !== 'object' || curr === null) return;

    for (const key of Object.keys(curr)) {
      const value = curr[key];
      const newPath = path ? `${path}.${key}` : key;

      if (newPath.endsWith(query)) {
        results.push(value);
      }

      if (typeof value === 'object') {
        recurse(value, newPath);
      }
    }
  };

  recurse(obj, '');

  if (results.length === 0) return undefined;
  return results[0];
};

export { getDeepByPath };
